import { ActionTypes } from "../Constants/ActionTypes";
import userService from "../../services/user.service";

export const setSelectedSchoolInformation = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SUPER_ADMIN_LOADING,
    payload: true,
  });
  userService
    .getSchoolDetails(payload.schoolId)
    .then((response) => {
      const data = response.data.data;

      dispatch({
        type: ActionTypes.GET_SELECTED_SCHOOL_INFORMATION,
        payload: data,
      });
      dispatch({
        type: ActionTypes.SUPER_ADMIN_LOADING,
        payload: false,
      });
    })
    .catch((error) => {
      dispatch({
        type: ActionTypes.SUPER_ADMIN_LOADING,
        payload: false,
      });
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
    });
};

export const deleteContactUsInquiry = async (dispatch, payload) => {
  const { apiToCall } = payload;
  dispatch({
    type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
    payload: false,
  });
  apiToCall();
};

export const restoreDeletedSchool = (dispatch, payload) => {
  const id = {
    schoolId: payload.schoolId,
  };
  userService
    .restoreSchool(id)
    .then((res) => {
      dispatch({
        type: ActionTypes.RESTORE_DELETED_SCHOOL,
        payload: false,
      });
      dispatch({
        type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
        payload: false,
      });
      dispatch({
        type: ActionTypes.OPEN_SUCCESS_POPUP,
        payload: {
          successPopUp: {
            message: "Recover Link Sent On Registered Email Id.",
            open: true,
          },
        },
      });
    })
    .catch((err) => {
      dispatch({
        type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
        payload: false,
      });
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
    });
};

export const deleteSchool = (dispatch, payload) => {
  const id = {
    schoolId: payload.schoolId,
  };
  userService
    .deleteSchoolId(id)
    .then((res) => {
      dispatch({
        type: ActionTypes.DELETE_SCHOOL,
        payload: true,
      });
      dispatch({
        type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
        payload: false,
      });
      dispatch({
        type: ActionTypes.OPEN_SUCCESS_POPUP,
        payload: {
          successPopUp: {
            message: "School Deleted Successfully.",
            open: true,
          },
        },
      });
    })
    .catch((err) => {
      dispatch({
        type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
        payload: false,
      });
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
    });
};

export const activateDeactivateSchool = (dispatch, payload) => {
  const status = !payload.status;
  userService
    .activateDeactivateSchool(payload.schoolId, status)
    .then((res) => {
      dispatch({
        type: ActionTypes.ACTIVATE_OR_DEACTIVATE_SCHOOL,
        payload: status,
      });
      dispatch({
        type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
        payload: false,
      });
      dispatch({
        type: ActionTypes.OPEN_SUCCESS_POPUP,
        payload: {
          successPopUp: {
            message: `School ${
              payload.status ? "Deactivated" : "Activated"
            } Successfully.`,
            open: true,
          },
        },
      });
    })
    .catch((err) => {
      dispatch({
        type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
        payload: false,
      });
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
    });
};
